export default function Logo({ className = "h-8 w-auto", dark = false, markOnly = false }) {
  const src = markOnly
    ? dark
      ? "/fikosan-mark-white.png"
      : "/fikosan-mark-deep.png"
    : dark
      ? "/dekrbat-logo-white.png"
      : "/dekrbat-logo-deep.png";
  return (
    <img
      src={src}
      alt="Dekrbat Pure"
      data-testid="fikosan-logo"
      className={className}
    />
  );
}
